import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import AttachItemIcon from '@material-ui/icons/Add'
import UpdateItemAmountIcon from '@material-ui/icons/Ballot'
import DetachItemIcon from '@material-ui/icons/DeleteForever'

import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

import PaperBlock from "../../../ui/PaperBlock"

import withStyles from '@material-ui/core/styles/withStyles'

const styles = theme => ({

})

/**
 <ControlPanel
 	template
	selected
	onAttachItemClick = {template, item}
	onEditItemAmountClick = {template, item}
	onDetachItemClick = {template, item}
	onMoveItemUp = {template, item}
	onMoveItemDown = {template, item}
/>
 */

class ControlPanel extends Component {

	render() {
		return <PaperBlock style = {{display: "flex"}}>

			<Tooltip title = "Добавить предмет"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onAttachItemClick === "function") {
							this.props.onAttachItemClick(this.props.template)
						}
					}}
				>
					<AttachItemIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Задать количество предметов"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditItemAmountClick === "function") {
							this.props.onEditItemAmountClick(this.props.template, this.props.selected)
						}
					}}
				>
					<UpdateItemAmountIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Удалить предмет"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDetachItemClick === "function") {
							this.props.onDetachItemClick(this.props.template, this.props.selected)
						}
					}}
				>
					<DetachItemIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Поднять выше"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onMoveItemUp === "function") {
							this.props.onMoveItemUp(this.props.template, this.props.selected)
						}
					}}
				>
					<ArrowUpwardIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Опустить ниже"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onMoveItemDown === "function") {
							this.props.onMoveItemDown(this.props.template, this.props.selected)
						}
					}}
				>
					<ArrowDownwardIcon />
				</Button>
			</div></Tooltip>

		</PaperBlock>
	}

}

export default withStyles(styles)(ControlPanel)
